import { httpServiceClient } from '@/infra/http'
import { NamingStrategy } from '@/infra/http/http-service-client/http-service-client-types'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import {
  UserEnrollmentContentInfoQuery,
  UserEnrollmentContentInfoResponse
} from './user-enrollment-content-info-service-types'
import { formatUserEnrollmentContentInfo } from './user-enrollment-content-info-service-utils'

const getUserContentUrl = () => makeApiUrl('/v2/user/content/product')

export const createUserEnrollmentContentInfoService = (client = httpServiceClient) => ({
  async fetchUserEnrollmentContentInfo(id: number, query: UserEnrollmentContentInfoQuery = {}) {
    const pathUrl = `${getUserContentUrl()}/${id}/enrollment`

    const response = await client<UserEnrollmentContentInfoResponse>({
      method: 'get',
      url: pathUrl,
      params: {
        toEnrollment: query.toEnrollment
      },
      paramsNamingStrategy: NamingStrategy.snakeCase
    })

    if (!response.body?.data) {
      throw new Error('User enrollment content info data not available')
    }

    return formatUserEnrollmentContentInfo(response.body.data as UserEnrollmentContentInfoResponse)
  }
})

export const userEnrollmentContentInfoService = createUserEnrollmentContentInfoService()
